import { useContext } from 'react';

import { useSuperAdmin } from 'hooks';
import { useHasuraClaims } from 'hooks';
import { SessionContext } from 'contexts/session';

// List of enterprise partner IDs that should have the kits dashboard enabled
// previously taken from LaunchDarkly
const KITS_DASHBOARD_ENABLED_IDS = [
  71, 5, 260, 183, 351, 129, 41, 133, 212, 386, 157, 77, 53, 297, 214, 235,
  424, 127, 282, 217, 118, 154, 336, 404, 122, 429, 377, 82, 67, 34, 50, 305,
  203, 321, 403, 44, 99, 393, 70, 423, 147, 265, 139, 370, 387, 68, 372, 422,
  446, 376, 433, 484, 469, 316
];

const useFlags = () => {
  const { user } = useContext(SessionContext);

  const { enterprisePartnerId } = useHasuraClaims();
  const { isEverlywellSuperAdmin, isMasqueradeMode, targetUserPartnerId } =
    useSuperAdmin();

  // Determine which partner ID to check against the enabled list
  const partnerIdToCheck = isEverlywellSuperAdmin && isMasqueradeMode
    ? targetUserPartnerId
    : enterprisePartnerId;

  // Check if the partner ID is in the list of enabled IDs
  const isKitsDashboardEnabled = KITS_DASHBOARD_ENABLED_IDS.includes(partnerIdToCheck);

  return {
    isKitsDashboardEnabled,
  };
};

export default useFlags;
